import { render, staticRenderFns } from "./oauth-shopify.vue?vue&type=template&id=8ead9eda&scoped=true&lang=pug&"
import script from "./oauth-shopify.vue?vue&type=script&lang=js&"
export * from "./oauth-shopify.vue?vue&type=script&lang=js&"
import style0 from "./oauth-shopify.vue?vue&type=style&index=0&id=8ead9eda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ead9eda",
  null
  
)

export default component.exports